import { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { useNavigate, Link } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { useThemeStore } from '../store/themeStore';
import { getDesignTokens } from '../utils/designTokens';
import ConfirmDialog from '../components/ConfirmDialog';

export default function Home() {
  const { isAuthenticated, signOut, signOutFromAllDevices } = useAuthStore();
  const navigate = useNavigate();
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);
  const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
  const [showSignOutMenu, setShowSignOutMenu] = useState(false);

  const handleSignOutThisDevice = () => {
    signOut();
    navigate('/login');
    setShowSignOutMenu(false);
  };

  const handleSignOutAllDevices = async () => {
    await signOutFromAllDevices();
    navigate('/login');
    setShowSignOutConfirm(false);
    setShowSignOutMenu(false);
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={`min-h-screen ${tokens.bg.gradient} relative transition-colors duration-300`}>
      <NavBar className={`${tokens.card.bg} ${tokens.card.shadow} ${tokens.card.border} border`} containerClassName="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between w-full items-center">
          <h1 className={`text-xl font-bold ${tokens.text.primary} font-serif`}>Runow</h1>
          <div className="flex items-center gap-3 sm:gap-4 relative">
            <div className="relative">
              <button
                onClick={() => setShowSignOutMenu(!showSignOutMenu)}
                className={`${tokens.button.secondary} px-4 h-12 min-w-[80px] flex items-center justify-center`}
              >
                Sign Out
              </button>
              {showSignOutMenu && (
                <div className={`absolute right-0 top-full mt-2 ${tokens.card.bg} ${tokens.border.light} border rounded-landing ${tokens.card.shadow} min-w-[200px] z-50`}>
                  <button
                    onClick={handleSignOutThisDevice}
                    className={`w-full ${tokens.text.primary} ${tokens.card.bg} hover:bg-opacity-80 px-4 py-3 text-left transition-colors min-h-[48px] flex items-center`}
                  >
                    Sign Out (This Device)
                  </button>
                  <button
                    onClick={() => {
                      setShowSignOutMenu(false);
                      setShowSignOutConfirm(true);
                    }}
                    className={`w-full ${tokens.text.primary} ${tokens.card.bg} hover:bg-opacity-80 px-4 py-3 text-left transition-colors min-h-[48px] flex items-center border-t ${tokens.border.light}`}
                  >
                    Sign Out (All Devices)
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </NavBar>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className={`border-4 border-dashed ${tokens.border.light} rounded-landing p-8 text-center`}>
            <h2 className={`text-xl font-semibold ${tokens.text.primary} mb-6 font-serif`}>
              Welcome to Runow!
            </h2>
            <p className={`text-sm ${tokens.text.muted} mb-6`}>
              Your family planning app is ready. More features coming soon.
            </p>
            <div className={`mt-6 space-y-2 text-xs ${tokens.text.muted}`}>
              <p>✅ Authentication: Configured</p>
              <p>⏳ Calendar: Coming in Phase 2</p>
              <p>⏳ Tasks: Coming in Phase 3</p>
              <p>⏳ Meal Planning: Coming in Phase 4</p>
            </div>
        </div>
      </main>

      {/* Sign Out Confirmation Dialog */}
      <ConfirmDialog
        isOpen={showSignOutConfirm}
        title="Sign Out from All Devices"
        message="This will sign you out from all devices where you're currently signed in. You'll need to sign in again on all devices. Continue?"
        confirmText="Sign Out Everywhere"
        cancelText="Cancel"
        onConfirm={handleSignOutAllDevices}
        onCancel={() => setShowSignOutConfirm(false)}
        isDestructive={true}
      />
    </div>
  );
}
